export const breakpoints = ['640px', '832px', '1024px'];

export const fontSize = {
  large5: '2.5rem',
  large4: '2rem',
  large3: '1.625rem',
  large2: '1.25rem',
  large: '1rem',
  normal: '0.875rem',
  small: '0.75rem',
  small2: '0.625rem',
};
